// Filtre de période pour les dashboards (7 / 30 / 90 derniers jours ou tout).
import { toDate } from './datetime';

export type Period = '7d' | '30d' | '90d' | 'all';

export const PERIOD_LABELS: Record<Period, string> = {
  '7d': '7 j',
  '30d': '30 j',
  '90d': '90 j',
  all: 'Tout',
};

const PERIOD_DAYS: Record<Exclude<Period, 'all'>, number> = {
  '7d': 7,
  '30d': 30,
  '90d': 90,
};

// Garde les éléments dans la fenêtre (inclusive du jour courant). `all` ne filtre rien.
export function filterByPeriod<T>(
  items: readonly T[],
  getDate: (item: T) => string,
  period: Period,
  now: Date = new Date(),
): T[] {
  if (period === 'all') return [...items];
  const cutoff = new Date(now);
  cutoff.setHours(0, 0, 0, 0);
  // Inclusif : 7 j = aujourd'hui + 6 jours précédents.
  cutoff.setDate(cutoff.getDate() - (PERIOD_DAYS[period] - 1));
  return items.filter((item) => toDate(getDate(item)) >= cutoff);
}
